const HEADER_OFFSET_FALLBACK = 85

export function websiteHeaderOffset() {
  return Number.parseFloat(
    getComputedStyle(document.documentElement).getPropertyValue("--website-header-offset")
  ) || HEADER_OFFSET_FALLBACK
}

export function elementDocumentTop(element) {
  return element.getBoundingClientRect().top + window.scrollY
}

export function catalogScrollTop(sidebar, fixedSidebar) {
  const overlap = Number.parseFloat(getComputedStyle(fixedSidebar).marginTop) || 0
  return Math.max(0, elementDocumentTop(sidebar) + overlap - websiteHeaderOffset())
}

export function animateWindowScroll(top, { duration, onComplete }) {
  const destination = Math.max(0, top)
  const start = window.scrollY
  const distance = destination - start

  if (distance === 0 || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    window.scrollTo(0, destination)
    const completionFrame = requestAnimationFrame(() => onComplete?.())
    return () => cancelAnimationFrame(completionFrame)
  }

  let animationFrame
  let cancelled = false
  const startedAt = performance.now()
  const step = timestamp => {
    if (cancelled) return

    const progress = Math.min((timestamp - startedAt) / duration, 1)
    const easedProgress = 0.5 - Math.cos(progress * Math.PI) / 2
    window.scrollTo(0, start + distance * easedProgress)

    if (progress < 1) {
      animationFrame = requestAnimationFrame(step)
    } else {
      // Let the final scroll event update Turbo's history before allowing navigation.
      animationFrame = requestAnimationFrame(() => {
        if (!cancelled) onComplete?.()
      })
    }
  }

  animationFrame = requestAnimationFrame(step)

  return () => {
    cancelled = true
    cancelAnimationFrame(animationFrame)
  }
}
